import defaultPalette from './default-palette';

export const palettes = {
  default: defaultPalette
};
